export default "<div class=\"card-block\">\n  <div class=\"card-text\">\n    <div id=\"settingsSiteSelectorReact\"></div>\n  </div>\n</div>\n";